import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import { FacCalloutInternal } from './index';

export class FACCalloutView extends Backbone.View {
  initialize({
    coupon,
    i18n,
    onActivate,
    userPreferenceService,
    siteMap,
    legacyScope,
    legacyInstrumentation,
    steps,
    scenarioName,
    refreshUserPreferencesCache,
    shouldHideForDaysAfterDismiss,
  }) {
    this.coupon = coupon;
    this.i18n = i18n;
    this.onActivate = onActivate;
    this.userPreferenceService = userPreferenceService;
    this.siteMap = siteMap;
    this.legacyScope = legacyScope;
    this.legacyInstrumentation = legacyInstrumentation;
    this.steps = steps;
    this.scenarioName = scenarioName;
    this.refreshUserPreferencesCache = refreshUserPreferencesCache;
    this.shouldHideForDaysAfterDismiss = shouldHideForDaysAfterDismiss;
  }

  render() {
    ReactDOM.render(
      <FacCalloutInternal
        i18n={this.i18n}
        coupon={this.coupon}
        onActivate={this.onActivate}
        userPreferenceService={this.userPreferenceService}
        siteMap={this.siteMap}
        legacyScope={this.legacyScope}
        legacyInstrumentation={this.legacyInstrumentation}
        steps={this.steps}
        scenarioName={this.scenarioName}
        refreshUserPreferencesCache={this.refreshUserPreferencesCache}
        shouldHideForDaysAfterDismiss={this.shouldHideForDaysAfterDismiss}
      />,
      this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
